import * as types from "./types";
import http from "@/http";

const actions = {
  [types.GET_SHADER_CHUNK](context, shadersUrl) {
    const endPoints = context.rootState.endPoints;
    const requestUrl = `${endPoints.customizer.s3ModelsBucket}${shadersUrl}`;
    return new Promise((resolve, reject) => {
      const name = shadersUrl.split(".")[0];
      if(context.state.shaders[name]) {
        resolve(context.state.shaders[name]);
      } else {
        http.get(requestUrl)
          .then((data) => {
            context.commit("SAVE_SHADER_CHUNKS", {shader: data.data, shaderName: name})
            resolve(data.data);
          })
          .catch(reject);
      }
    });
  }
};
export default actions;
